import moment from '../../../services/unifiedMoment';
import { mesesFormat } from '../../../utils/formatting';
import { REGIMEN_OPTIONS } from '../../../utils/regimen.options';

export type FechaOptions = Array<{ value: string; label: string }>;

export const DAY_IN_MS = 86400000;

/** RFC used by SAT for "Publico en general" receptors */
export const GENERIC_RFC = 'XAXX010101000';

export const REGIMEN_OPT = REGIMEN_OPTIONS.map((o) => ({ value: o.value, label: o.secondLabel }));

export const GLOBAL_PERIODO_OPT = [
    { value: '01', label: 'Diario' },
    { value: '02', label: 'Semanal' },
    { value: '03', label: 'Quincenal' },
    { value: '04', label: 'Mensual' },
];

export const GLOBAL_MES = new Array(12).fill(1).map((_, i) => ({
    value: mesesFormat(`${i + 1}`),
    label: moment().startOf('year').add(i, 'month').format('MMMM')
}));

/** Global bills can only be issued for the current or previous year */
export function globalAnoOptions() {
    return new Array(2).fill(1).map((_, i) => ({
        value: `${new Date().getFullYear() - i}`,
        label: `${new Date().getFullYear() - i}`
    }));
}

export function setFechaOptions(dateNow: number): FechaOptions {
    return [
        { value: '', label: 'Hoy' },
        { value: new Date(dateNow - DAY_IN_MS).toJSON(), label: 'Hace 1 día' },
        { value: new Date(dateNow - 2 * DAY_IN_MS).toJSON(), label: 'Hace 2 días' },
        { value: new Date(dateNow - 2.9 * DAY_IN_MS).toJSON(), label: 'Hace 3 días' }, // Little less than 72 hrs
    ];
}
